<template>
  <div class="sign-in" style="overflow: hidden">
    <a-row type="flex" :gutter="[10, 10]" justify="center" align="middle">
      <a-col
        :span="120"
        :md="12"
        :lg="12"
        :xl="12"
        class="col-img"
        style="display: flex; justify-content: center"
      >
        <img style="margin-top: 0 !important;" src="images/gifs/sign-in.gif" alt="" />
      </a-col>

      <a-col
        :span="120"
        :md="6"
        :lg="{ span: 6, offset: 0 }"
        :xl="{ span: 6, offset: 2 }"
        class="col-form"
        style="margin-left: 0;    margin-top: 65px;"
      >
             <div style="display:flex ;justify-content: right;" >
             <img class="mb-15" src="images/Icon.jpg" alt="" width="50px" />

              <h2 class="mb-15" > آسان تهاتر ایرانیان</h2>

             </div>


        <!-- Sign In Form -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
          :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="شماره همراه" :colon="false">
            <a-input
            name="phone"
              v-decorator="[
                'phone',
                {
                  rules: [
                    { required: true, message: 'لطفا شماره همراه خود را وارد کنید' },
                  ],
                },
              ]"
              placeholder="0912*******"
            />
          </a-form-item>
          <a-form-item class="mb-5" label="پسورد" :colon="false">
            <a-input
            name="password"
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'لطفا پسورد خود را وارد کنید' },
                  ],
                },
              ]"
              type="password"
              placeholder="********"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              block
              html-type="submit"
              class="login-form-button"
            >
              ورود
            </a-button>
          </a-form-item>
        </a-form>
       <ForgotPassModal />
        <!-- / Sign In Form -->
      </a-col>
      <!-- / Sign In Form Column -->
    </a-row>
  </div>
</template>

<script>
	import ForgotPassModal from '../components/Blocks/ForgetPassModal' ;

export default {
  components: {
			ForgotPassModal,
		},
  data() {
    return {

    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.login(e);
        }
      });
    },
    async login(event) {
      let _this = this;
      let data = new FormData(event.target);
     await axios
        .post("/login", data)
        .then(function (response) {
          const data=response.data;
          _this.$store.commit('isLogin',data);
          location.href = "/dashboard";
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
  
  },

};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}
</style>
